/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Mock_Btn_ApproveInputs */

const tr_landing_telegram_mock_btn_approve = /** @type {(inputs: Landing_Telegram_Mock_Btn_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onayla`)
};

const en_landing_telegram_mock_btn_approve = /** @type {(inputs: Landing_Telegram_Mock_Btn_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve`)
};

const de_landing_telegram_mock_btn_approve = /** @type {(inputs: Landing_Telegram_Mock_Btn_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigen`)
};

const ru_landing_telegram_mock_btn_approve = /** @type {(inputs: Landing_Telegram_Mock_Btn_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтвердить`)
};

/**
* | output |
* | --- |
* | "Approve" |
*
* @param {Landing_Telegram_Mock_Btn_ApproveInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_mock_btn_approve = /** @type {((inputs?: Landing_Telegram_Mock_Btn_ApproveInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Mock_Btn_ApproveInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_mock_btn_approve(inputs)
	if (locale === "de") return de_landing_telegram_mock_btn_approve(inputs)
	if (locale === "ru") return ru_landing_telegram_mock_btn_approve(inputs)
	return tr_landing_telegram_mock_btn_approve(inputs)
});